function alignImages() {
    var $projectItems = $('.project-item');
    // Reset any previous transform adjustments on the images and title spans
    $projectItems.find('picture.project-image').css('transform', '');
    $projectItems.find('a > span').css('transform', '');

    // Group project items by their top offset
    var rows = {};
    $projectItems.each(function () {
        var $item = $(this);
        var topOffset = Math.round($item.offset().top);
        if (!rows[topOffset]) {
            rows[topOffset] = [];
        }
        rows[topOffset].push($item);
    });

    // For each row, calculate the maximum title height and adjust image and title positions
    $.each(rows, function (rowTop, items) {
        var maxTitleHeight = 0;
        items.forEach(function ($item) {
            // Get the title height from the <span> inside the <a>
            var titleHeight = $item.find('a > span').outerHeight();
            if (titleHeight > maxTitleHeight) {
                maxTitleHeight = titleHeight;
            }
        });

        // Adjust each image's and title's position so the gap is eliminated
        items.forEach(function ($item) {
            var titleHeight = $item.find('a > span').outerHeight();
            var diff = maxTitleHeight - titleHeight;
            if (diff > 0) {
                // Shift both the image and title upward by the same amount
                $item.find('picture.project-image').css('transform', 'translateY(-' + diff + 'px)');
                $item.find('a > span').css('transform', 'translateY(-' + diff + 'px)');
            }
        });
    });
}

$(document).ready(function () {
    alignImages();
});

$(window).on('resize', function () {
    alignImages();
});
